
// language
import { injectIntl, IntlShape } from 'react-intl';

// components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SegmentedBar from 'components/SegmentBar';


type Props = {
    intl: IntlShape,
    type?: string,
    warningTime?: number,
}

const LegendTable = ( { intl, type, warningTime }: Props ) => {

    return (
        <MDBox
            sx={{
                display: "flex", flexDirection: "row",
                gap: "1rem", marginLeft: "max(18.7rem)",
            }}
        >
            <MDBox
                sx={{
                    display: "flex", flexDirection: "column",
                    paddingTop: "0.9rem", paddingBottom: "0.9rem",
                    width: "-moz-available",
                }}
            >
                <MDBox
                    sx={{
                        display: "flex", flexDirection: "row",
                        gap: "0.5rem", paddingBottom: "0.5rem",
                    }}
                >
                    <MDBox
                        sx={{ 
                            width: '1.25rem', height: '1.25rem', 
                            backgroundColor: 'rgba(217, 255, 2, 0.45)', borderRadius: "0.19rem",
                            border: "1px solid #fff",
                        }}
                    />
                    <MDTypography
                        sx={{
                            fontSize: "0.75rem", fontWeight: "700", color: "#807E7B"
                        }}
                    >
                        {intl.formatMessage({id:'tableReservations.newRes'})}
                    </MDTypography>
                </MDBox>
                <MDBox
                    sx={{
                        display: "flex", flexDirection: "row",
                        gap: "0.5rem", paddingBottom: "0.5rem",
                    }}
                >
                    <MDBox
                    sx={{ 
                        width: '1.25rem', height: '1.25rem', 
                        backgroundColor: 'rgba(0, 111, 238, 0.15)', borderRadius: "0.19rem",
                        border: "1px solid #fff",
                    }}
                    />
                    <MDTypography
                    sx={{
                        fontSize: "0.75rem", fontWeight: "700", color: "#807E7B"
                    }}
                    >
                        {intl.formatMessage({id:'tableReservations.nextDayRes'})}
                    </MDTypography>
                </MDBox>
                <MDBox
                    sx={{
                        display: "flex", flexDirection: "row", gap: "0.5rem",
                        paddingBottom: "0.5rem",
                    }}
                >
                    <MDBox
                        sx={{ 
                            width: '1.25rem', height: '1.25rem', 
                            backgroundColor: 'rgba(12, 14, 12, 0.08)', borderRadius: "0.19rem",
                            border: "1px solid #fff",
                        }}
                    />
                    <MDTypography
                        sx={{
                            fontSize: "0.75rem", fontWeight: "700", color: "#807E7B"
                        }}
                    >
                        {intl.formatMessage(
                            {id:'tableReservations.fineRes'},
                            {warningTime}
                        )}
                    </MDTypography>
                </MDBox>
            </MDBox>
        </MDBox>

    )
}

export default injectIntl(LegendTable);